"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixcloudAudio1Schema = void 0;
exports.MixcloudAudio1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/mixcloud-audio/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MixcloudAudio1",
    "description": "Embed a mixcloud track",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:mixcloud-audio:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "assetType": {
                    "type": "string",
                    "default": "show",
                    "enum": [
                        "playlist",
                        "profile",
                        "show"
                    ]
                },
                "href": {
                    "type": "string",
                    "description": "The URL of a mixcloud track"
                }
            },
            "required": [
                "href"
            ]
        }
    },
    "required": [
        "type",
        "attributes"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9taXhjbG91ZC1hdWRpby8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9CQUFvQixHQUFHO0lBQ2xDLEtBQUssRUFBRSxtRkFBbUY7SUFDMUYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZ0JBQWdCO0lBQ3pCLGFBQWEsRUFBRSx3QkFBd0I7SUFDdkMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLDJDQUEyQzthQUM1QztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLFdBQVcsRUFBRTtvQkFDWCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsU0FBUyxFQUFFLE1BQU07b0JBQ2pCLE1BQU0sRUFBRTt3QkFDTixVQUFVO3dCQUNWLFNBQVM7d0JBQ1QsTUFBTTtxQkFDUDtpQkFDRjtnQkFDRCxNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSw2QkFBNkI7aUJBQzdDO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsTUFBTTthQUNQO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixZQUFZO0tBQ2I7Q0FDRixDQUFBIn0=